import React from 'react'
import { NotificationInterface } from '../components/UI/NotificationProvider'
import upperFirst from 'lodash/upperFirst'

export const withHandledErrors = async (
  notification: NotificationInterface,
  cb: () => void,
  successMessage?: string | null,
  errorMessage?: string | null,
) => {
  const { showSuccess, showError } = notification

  try {
    await cb()

    if (successMessage !== null) {
      showSuccess(successMessage || 'Success')
    }
  } catch (error) {
    if (error.response?.data?.state) {
      return
    }

    let messages = error.response?.data?.message

    if (!Array.isArray(messages)) {
      messages = [messages]
    }

    const code = error.response?.status

    let title = 'Something went wrong'

    switch (code) {
      case 400: {
        title = 'Validation error'
        break
      }

      case 404:
        title = 'Not found'
    }

    if (messages?.length === 1) {
      title = messages[0]
    }

    if (errorMessage !== null) {
      showError(
        errorMessage || title,
        !!messages?.length && messages.length > 1 && (
          <>
            {messages.map((item, i) => (
              <div key={i}>{upperFirst(item)}</div>
            ))}
          </>
        ),
      )
    }
  }
}
